module.exports = __webpack_public_path__ + "img/return_icon.de497b66.svg";